import React, { Component } from 'react'
import DateTime from 'react-datetime'
import 'react-datetime/css/react-datetime.css'

const params = {
  dateFormat: "DD.MM.YYYY",
  timeFormat: "HH:mm",
}

class DateTimePicker extends Component {
  handleChange = (moment) => {
    if (typeof ev === 'string') {
      return
    }
    const target = {
      name: this.props.name,
      value: moment._d 
    }
    this.props.handleChange({ target });
  }

  render() {
    const {
      className,
      placeholder = 'Date/Time',
      readOnly,
      value,
      ...rest
    } = this.props;
    return (
      <DateTime 
        {...params}
        inputProps={{
          className,
          placeholder,
          // readOnly
        }}
        value={value}
        onChange={this.handleChange}
        {...rest} />
    )
  }
}

export default DateTimePicker


// WEBPACK FOOTER //
// ./src/components/micro/DateTime.js